module.exports = __webpack_public_path__ + "img/step_2.59233c9a.png";